import React from 'react';

export type PillKind = 'neutral' | 'success' | 'warning' | 'danger';

interface PillProps {
  kind?: PillKind;
  children: React.ReactNode;
  className?: string;
  role?: string;
}

/**
 * Canonical pill component for status labels and short notices.
 * Replaces ad-hoc `<span className="pill warning">...</span>` usage
 * across Portal routes.
 *
 * For longer multi-line notices and retryable errors, prefer
 * `<Notice>` from the same module.
 */
export const Pill = ({ kind = 'neutral', children, className, role }: PillProps): JSX.Element => {
  const variantClass = kind === 'neutral' ? '' : ` ${kind}`;
  const composedClassName = `pill${variantClass}${className ? ` ${className}` : ''}`;
  return (
    <span className={composedClassName} role={role}>
      {children}
    </span>
  );
};
